import { render, staticRenderFns } from "./PermissionsPage.vue?vue&type=template&id=07dd4006&scoped=true&"
import script from "./PermissionsPage.vue?vue&type=script&lang=js&"
export * from "./PermissionsPage.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsPage.vue?vue&type=style&index=0&id=07dd4006&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd4006",
  null
  
)

export default component.exports